import accommodationList from './AccommodationList/en.json';
import chat from './Chat/en.json';
import common from './Common/en.json';
import consent from './Consent/en.json';
import forgotPassword from './ForgotPassword/en.json';
import main from './Main/en.json';
import signIn from './SignIn/en.json';
import signUp from './SignUp/en.json';
import transportList from './TransportList/en.json';

export default {
  accommodationList,
  chat,
  common,
  consent,
  forgotPassword,
  signIn,
  signUp,
  transportList,
  main
};
